module.exports = __webpack_public_path__ + "img/voiceForm.5dcc4817.jpg";